
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/insights/subscription-success",
      function () {
        return require("private-next-pages/us/insights/subscription-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/insights/subscription-success"])
      });
    }
  